import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../lib/site";

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 max-w-7xl mx-auto px-6 lg:px-8"
    >
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="label-eyebrow text-brand-terracotta mb-5">Common questions</div>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight font-medium text-brand-ink">
            Smart answers, no fine print.
          </h2>
          <p className="mt-6 text-base md:text-lg text-brand-ink/70 leading-relaxed">
            Still have a question? Call us on{" "}
            <a
              href="tel:+61404123038"
              data-testid="faq-phone-link"
              className="text-brand-eucalyptus underline underline-offset-4 hover:text-brand-terracottaDark"
            >
              0404 123 038
            </a>{" "}
            — we&apos;re happy to help.
          </p>
        </div>
        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-border"
              >
                <AccordionTrigger className="font-display text-lg md:text-xl text-left text-brand-ink hover:text-brand-terracotta py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-brand-ink/70 leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
